import UnassignedField from '@/components/global/fields/UnassignedField.jsx';
import PropTypes from 'prop-types';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

const mobileIdStyles = {
    fontWeight: 600,
    fontSize: '14px',
    display: 'inline-block !important',
    width: 'max-content !important',
    border: 'none !important',
};

const addressStyles = {
    display: 'block !important',
    fontSize: '11px !important',
    width: 'max-content',
    lineHeight: '16px',
    marginTop: '2px',
    minWidth: '230px',
};

const mobileAddressStyles = {
    minWidth: 'auto',
};

const formatAddress = address => {
    const locality = [address?.postalCode, address?.city].filter(Boolean).join(' ');

    return [address?.address, locality].filter(Boolean).join(', ');
};

const ListCollectionPointField = ({ collectionPoint, sx, onClick, showShopName = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.values.lg}px)`);
    const isInteractive = !isMobile && typeof onClick === 'function';

    if (!collectionPoint) {
        return <UnassignedField />;
    }

    const content = (
        <>
            <Typography component='strong' variant='inherit' sx={isMobile ? mobileIdStyles : undefined}>
                {collectionPoint.customId}
            </Typography>
            {showShopName && collectionPoint.shopName ? `, ${collectionPoint.shopName}` : null}
            <Typography component='span' sx={{ ...addressStyles, ...(isMobile ? mobileAddressStyles : {}) }}>
                {formatAddress(collectionPoint.address)}
            </Typography>
        </>
    );

    if (isInteractive) {
        return (
            <Box
                component='button'
                type='button'
                onClick={onClick}
                sx={{
                    ...sx,
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    textAlign: 'left',
                    font: 'inherit',
                    color: 'inherit',
                }}
            >
                {content}
            </Box>
        );
    }

    return <Box sx={{ ...sx, cursor: 'default' }}>{content}</Box>;
};

ListCollectionPointField.propTypes = {
    collectionPoint: PropTypes.shape({
        customId: PropTypes.string.isRequired,
        shopName: PropTypes.string,
        address: PropTypes.shape({
            address: PropTypes.string,
            postalCode: PropTypes.string,
            city: PropTypes.string,
        }),
    }),
    sx: PropTypes.object,
    onClick: PropTypes.func,
    showShopName: PropTypes.bool,
};

export default ListCollectionPointField;
